import React from 'react';
import "./css/Footer.css"

const Footer = () => {
  return (
    <div>

<section id='footer'>

    <div className='container-fluid'>
<div className='jumbotron'>
<div className=' col col-md-12'>
 
  
<div>
   <a href="https://linkedin.com/in/kishor24" target="_blank" rel="noopener noreferrer"><i class="fa-brands fa-linkedin"></i></a>   
  <a href="https://github.com/Kishorkumar63" target="_blank" rel="noopener noreferrer"> <i class="fa-brands fa-github"></i></a>   
     </div>

     <h5>  <i class="fa-sharp fa-solid fa-copyright"></i>  Kishor Kumar K. All right reserved</h5>
</div>

</div>

    </div>
</section>

    </div>
  )
}

export default Footer